import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { CreditMetaModel } from "common/models/page-models/credits/credit-meta-model";
import { AppVersionModel } from "common/models/page-models/App Version Model/app-version-form-model";
import { AppVersionFormDataService } from "common/services/data-services/admin/app-version/app-version-formdata.service";
import { AppVersionFormmetaModel } from "common/models/page-models/App Version Model/app-version-form-meta.model";
import { SystemService } from "common/services/core-services/system.service";



@Injectable({
    providedIn: 'root'
})
export class AppVersionFormWidgetService extends FormWidgetService<AppVersionModel> {
    constructor(protected ds: AppVersionFormDataService,
        private ss: SystemService,
    ) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new AppVersionFormmetaModel();
        return meta.getMetaModel();
    }

    Save(body, url) {
        this.ds.postLoginData(body, url).then((response) => {

            if (response.status === 'Success') {
                this.ss.showSuccess(response.msg);
            }

        });
    }
}
